import axios from "axios";
import i18n, { LOCALE_KEY } from "../i18n";
import { attachAuthRefresh } from "./authRefresh";
import { DEVICE_ID_HEADER, getOrCreateWebDeviceId } from "../lib/deviceId";

const client = axios.create({
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

client.interceptors.request.use((config) => {
  const lang =
    localStorage.getItem(LOCALE_KEY) || i18n.language || navigator.language;
  config.headers["Accept-Language"] = lang;
  config.headers[DEVICE_ID_HEADER] = getOrCreateWebDeviceId();
  return config;
});

attachAuthRefresh(client);

export default client;
